export const StatusPrimarySecondary = {
    PRIMARY: "PRIMARY",
    SECONDARY: "SECONDARY"
}

export const StatusPrimarySecondaryClassname = {
    PRIMARY: "primary",
    SECONDARY: "secondary"
}